// extracted by mini-css-extract-plugin
export default {"highlight":"drawer_highlight__JsE8a","preText":"drawer_preText__XUbcH"};